<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <div class="page-header row no-gutters py-4">
      <div class="col-12 col-sm-4 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle">Components</span>
        <h3 class="page-title">Add Dates/Times</h3>
      </div>
    </div>
    <p>
      <router-link to="/booking-time-slot"
        ><i class="material-icons mr-1">arrow_back</i>Back</router-link
      >
    </p>
    <d-card>
      <d-card-body>
        <d-col col sm="10" class="d-flex mb-2 mb-sm-3">
          <d-col sm="3"><label>Days Of the Event</label></d-col>
          <d-input-group
            size="sm"
            class="date-range d-flex justify-content-left"
          >
            <d-datepicker
              v-model="dateRange.from"
              :highlighted="{
                from: dateRange.from,
                to: dateRange.to || new Date(),
              }"
              placeholder="Start Date"
              typeable
              small
            />
            <d-datepicker
              v-model="dateRange.to"
              :highlighted="{
                from: dateRange.from,
                to: dateRange.to || new Date(),
              }"
              placeholder="End Date"
              typeable
              small
            />
            <d-input-group-text slot="append">
              <i class="material-icons">&#xE916;</i>
            </d-input-group-text>
          </d-input-group>
        </d-col>

        <d-col col sm="10" class="d-flex mb-2 mb-sm-0">
          <div class="form-group">
            <d-col sm="5"
              ><label class="d-block">Including These Days:</label></d-col
            >
            <d-checkbox inline v-model="weekday" name="weekday" value="Monday"
              >Monday</d-checkbox
            >
            <d-checkbox inline v-model="weekday" name="weekday" value="Tuesday"
              >Tuesday</d-checkbox
            >
            <d-checkbox
              inline
              v-model="weekday"
              name="weekday"
              value="Wednesday"
              >Wednesday</d-checkbox
            >
            <d-checkbox inline v-model="weekday" name="weekday" value="Thursday"
              >Thursday</d-checkbox
            >
            <d-checkbox inline v-model="weekday" name="weekday" value="Friday"
              >Friday</d-checkbox
            >
            <d-checkbox inline v-model="weekday" name="weekday" value="Saturday"
              >Saturday</d-checkbox
            >
            <d-checkbox inline v-model="weekday" name="weekday" value="Sunday"
              >Sunday</d-checkbox
            >
          </div>
        </d-col>

        <d-row class="my-1" v-for="type in inputTypes" :key="type">
          <d-col sm="2"><label>Time Range:</label></d-col>
          <d-col sm="3"
            ><d-form-input
              :id="`type-${type}`"
              :type="type"
              v-model="timeRange.from"
            ></d-form-input
          ></d-col>
          <d-col sm="1"><label>to</label></d-col>
          <d-col sm="3"
            ><d-form-input
              :id="`type-${type}`"
              :type="type"
              v-model="timeRange.to"
            ></d-form-input
          ></d-col>
          <d-button outline pill @click="addTime">Add</d-button>
        </d-row>
        <d-row>
          <d-col sm="2"><label>Participiants:</label></d-col>
          <d-col sm="2"
            ><d-input type="number" v-model="participant" class="mb-2"
          /></d-col>
        </d-row>
        <div class="container" v-if="list.length > 0">
          <h5 class="text-left">Timeslots</h5>
          <table class="table table-striped table-bordered">
            <thead>
              <tr>
                <th>#</th>
                <th>Begin Time</th>
                <th>End Time</th>
                <th>Number Of Available Participant</th>
                <th>Remove</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="( item, index ) in list" :key="index">
                <td>{{ index+1 }}</td>
                <td>{{ item.beginTime }}</td>
                <td>{{ item.endTime }}</td>
                <td>{{ item.totalAvailabele }}</td>
                <td>
                  <d-button outline pill v-on:click="removeTime(index)">Remove</d-button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <d-button @click.prevent="post()">Add Time Slots</d-button>
      </d-card-body>
    </d-card>
  </d-container>
</template>

<script>
import axios from "axios";

export default {
  name: "users-overview",
  data() {
    return {
      participant: "",
      list: [],
      timeRange: {
        from: null,
        to: null,
      },
      weekday: [],
      inputTypes: ["time"],
      dateRange: {
        from: null,
        to: null,
      },
      timeslot: [],
      date: new Date(),
    };
  },
  methods: {
    post() {
      axios
        .post(process.env.VUE_APP_API+"api/staff/TimeSlot", {
          dateRange: this.dateRange,
          weekdays: this.weekday,
          timeslots: this.list,
        })
        .catch((err) => {
          alert(err);
        });
    },
    addTime: function () {
      var timeslot = {
        beginTime: this.timeRange.from,
        endTime: this.timeRange.to,
        totalAvailabele: this.participant,
      };
      this.list.push(timeslot);
    },
    removeTime: function (index) {
      this.list.pop();
    },
  },
};
</script>

